import React, { useContext, useEffect, useState } from "react";
import { downloadCSV, formatDate } from "../../../services/util";
import { SettingContext } from "../../../routes";
import moment from "moment-timezone";
import { Button, Card, Select, Skeleton } from "antd";
import NexusHeader from "../NexusHeader";
import CustomTable from "../../common/Table";
import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import HTTP from "../../../services/httpService";
import { calculateWaitingTime } from "../constant";
import timeZoneArray from "../../../services/timezone.json";

const { Option } = Select;

const findTimezoneByUtc = (utcValue) => {
    const timezone = timeZoneArray.find((tz) => tz.utc.includes(utcValue));
    return timezone ? timezone.value : "America/Detroit";
};

const CallWaitingDetails = () => {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const {
        state: { hotel_id, kiosk_id, tz_id },
    } = useLocation();
    const { selectedNexusDates, setSelectedNexusDates } =
        useContext(SettingContext);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedTimeZone, setSelectedTimeZone] = useState(
        findTimezoneByUtc(tz_id),
    );
    const [start_date, end_date] = selectedNexusDates;
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date, "YYYY/MM/DD HH:mm:SS"),
        end_date: formatDate(end_date, "YYYY/MM/DD HH:mm:SS"),
        page: 0,
        limit: 10,
        staff_id,
        sorting: "",
        sort_by: "",
        tz_id: tz_id,
        all_selected: false,
        need_live_count: false,
        hotel_ids: [hotel_id],
        is_for_report: false,
        kiosk_id,
    });

    const {
        status: hotelCallWaitingStatus,
        data: hotelCallWaitingRes,
        refetch: fetchHotelCallWaitingDetails,
    } = useQuery(
        `callWaiting${hotel_id}`,
        async () => {
            return await HTTP("/nexus/getNexusCallWaitingDetailsHotelWise", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchHotelCallWaitingDetails();
    }, []);

    useEffect(() => {
        fetchHotelCallWaitingDetails();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedNexusDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date, "YYYY/MM/DD HH:mm:SS"),
            end_date: formatDate(end_date, "YYYY/MM/DD HH:mm:SS"),
            tz_id: timeZoneArray.filter((t) => t.value === selectedTimeZone)[0]
                .utc[0],
        });
    }, [selectedNexusDates, selectedTimeZone]);

    useEffect(() => {
        if (hotelCallWaitingStatus === "success") {
            const { data: hotelCallWaitingData, total } = hotelCallWaitingRes;
            setTotalRecords(total);
            setTableData(hotelCallWaitingData);
        }
    }, [hotelCallWaitingStatus, hotelCallWaitingRes]);

    const getDateUsingTimeZone = (datevalue) => {
        if (datevalue) {
            return moment
                .utc(datevalue)
                .tz(
                    timeZoneArray.filter((t) => t.value === selectedTimeZone)[0]
                        .utc[0],
                )
                .format("YYYY/MM/DD HH:mm:SS");
        }
        return "-";
    };

    const columns = [
        {
            title: "Date",
            dataIndex: "missed_call_at",
            key: "missed_call_at",
            render: (text, record) => getDateUsingTimeZone(text),
        },
        {
            title: "Call Waiting Time",
            dataIndex: "call_start_at_kiosk_time",
            key: "call_start_at_kiosk_time",
            render: (text, record) => calculateWaitingTime(record),
        },
    ];

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        setFormData({
            ...formData,
            page: current - 1,
            limit: pageSize,
        });
        setCurrentPage(current);
    }

    async function downalodReport() {
        const tempFormData = { ...formData };
        tempFormData.start_date = formatDate(start_date, "YYYY/MM/DD HH:mm:SS");
        tempFormData.end_date = formatDate(end_date, "YYYY/MM/DD HH:mm:SS");
        tempFormData.is_for_report = true;
        const res = await HTTP("/nexus/getNexusCallWaitingDetailsHotelWise", {
            ...tempFormData,
        });
        downloadCSV(res, `call_waiting_reports`);
    }

    const showExtraComponents = () => {
        return (
            <>
                <Select
                    showSearch
                    onChange={(e) => setSelectedTimeZone(e)}
                    style={{ width: 280, marginRight: 4 }}
                    defaultValue={selectedTimeZone}
                >
                    {timeZoneArray.map((tz) => (
                        <Option key={tz.value} value={tz.value}>
                            {tz.text}
                        </Option>
                    ))}
                </Select>
                <Button
                    type="primary"
                    className="margin-right-5"
                    onClick={downalodReport}
                >
                    Download
                </Button>
            </>
        );
    };

    return (
        <Card className="dashboard-container">
            <NexusHeader
                showBackButton={true}
                isRefreshAllowed={false}
                showRangePicker={true}
                selectedTimeZone={selectedTimeZone}
                setSelectedTimeZone={setSelectedTimeZone}
                extraAfter={showExtraComponents()}
                withTime={true}
                selectedDateTime={selectedNexusDates}
                setSelectedDatetime={setSelectedNexusDates}
            />
            {hotelCallWaitingStatus === "loading" ||
            hotelCallWaitingStatus === "idle" ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            ) : (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    noOfrecords={totalRecords}
                    currentPage={currentPage}
                    handleTableChange={handleTableChange}
                    rowKey="kiosk_id"
                />
            )}
        </Card>
    );
};

export default CallWaitingDetails;
